{
  "main": {
    "en": {
      "identity": {
        "language": "en"
      },
      "dates": {
        "calendars": {
          "gregorian": {
            "months": {
              "format": {
                "abbreviated": {
                  "1": "Jan",
                  "2": "Feb",
                  "3": "Mar",
                  "4": "Apr",
                  "5": "May",
                  "6": "Jun",
                  "7": "Jul",
                  "8": "Aug",
                  "9": "Sep",
                  "10": "Oct",
                  "11": "Nov",
                  "12": "Dec"
                },
                "narrow": {
                  "1": "J",
                  "2": "F",
                  "3": "M",
                  "4": "A",
                  "5": "M",
                  "6": "J",
                  "7": "J",
                  "8": "A",
                  "9": "S",
                  "10": "O",
                  "11": "N",
                  "12": "D"
                },
                "wide": {
                  "1": "January",
                  "2": "February",
                  "3": "March",
                  "4": "April",
                  "5": "May",
                  "6": "June",
                  "7": "July",
                  "8": "August",
                  "9": "September",
                  "10": "October",
                  "11": "November",
                  "12": "December"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "1": "Jan",
                  "2": "Feb",
                  "3": "Mar",
                  "4": "Apr",
                  "5": "May",
                  "6": "Jun",
                  "7": "Jul",
                  "8": "Aug",
                  "9": "Sep",
                  "10": "Oct",
                  "11": "Nov",
                  "12": "Dec"
                },
                "narrow": {
                  "1": "J",
                  "2": "F",
                  "3": "M",
                  "4": "A",
                  "5": "M",
                  "6": "J",
                  "7": "J",
                  "8": "A",
                  "9": "S",
                  "10": "O",
                  "11": "N",
                  "12": "D"
                },
                "wide": {
                  "1": "January",
                  "2": "February",
                  "3": "March",
                  "4": "April",
                  "5": "May",
                  "6": "June",
                  "7": "July",
                  "8": "August",
                  "9": "September",
                  "10": "October",
                  "11": "November",
                  "12": "December"
                }
              }
            },
            "days": {
              "format": {
                "abbreviated": {
                  "sun": "Sun",
                  "mon": "Mon",
                  "tue": "Tue",
                  "wed": "Wed",
                  "thu": "Thu",
                  "fri": "Fri",
                  "sat": "Sat"
                },
                "narrow": {
                  "sun": "S",
                  "mon": "M",
                  "tue": "T",
                  "wed": "W",
                  "thu": "T",
                  "fri": "F",
                  "sat": "S"
                },
                "short": {
                  "sun": "Su",
                  "mon": "Mo",
                  "tue": "Tu",
                  "wed": "We",
                  "thu": "Th",
                  "fri": "Fr",
                  "sat": "Sa"
                },
                "wide": {
                  "sun": "Sunday",
                  "mon": "Monday",
                  "tue": "Tuesday",
                  "wed": "Wednesday",
                  "thu": "Thursday",
                  "fri": "Friday",
                  "sat": "Saturday"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "sun": "Sun",
                  "mon": "Mon",
                  "tue": "Tue",
                  "wed": "Wed",
                  "thu": "Thu",
                  "fri": "Fri",
                  "sat": "Sat"
                },
                "narrow": {
                  "sun": "S",
                  "mon": "M",
                  "tue": "T",
                  "wed": "W",
                  "thu": "T",
                  "fri": "F",
                  "sat": "S"
                },
                "short": {
                  "sun": "Su",
                  "mon": "Mo",
                  "tue": "Tu",
                  "wed": "We",
                  "thu": "Th",
                  "fri": "Fr",
                  "sat": "Sa"
                },
                "wide": {
                  "sun": "Sunday",
                  "mon": "Monday",
                  "tue": "Tuesday",
                  "wed": "Wednesday",
                  "thu": "Thursday",
                  "fri": "Friday",
                  "sat": "Saturday"
                }
              }
            },
            "quarters": {
              "format": {
                "abbreviated": {
                  "1": "Q1",
                  "2": "Q2",
                  "3": "Q3",
                  "4": "Q4"
                },
                "narrow": {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4"
                },
                "wide": {
                  "1": "1st quarter",
                  "2": "2nd quarter",
                  "3": "3rd quarter",
                  "4": "4th quarter"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "1": "Q1",
                  "2": "Q2",
                  "3": "Q3",
                  "4": "Q4"
                },
                "narrow": {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4"
                },
                "wide": {
                  "1": "1st quarter",
                  "2": "2nd quarter",
                  "3": "3rd quarter",
                  "4": "4th quarter"
                }
              }
            },
            "dayPeriods": {
              "format": {
                "abbreviated": {
                  "midnight": "midnight",
                  "am": "AM",
                  "am-alt-variant": "am",
                  "noon": "noon",
                  "pm": "PM",
                  "pm-alt-variant": "pm",
                  "morning1": "in the morning",
                  "afternoon1": "in the afternoon",
                  "evening1": "in the evening",
                  "night1": "at night"
                },
                "narrow": {
                  "midnight": "mi",
                  "am": "a",
                  "am-alt-variant": "am",
                  "noon": "n",
                  "pm": "p",
                  "pm-alt-variant": "pm",
                  "morning1": "in the morning",
                  "afternoon1": "in the afternoon",
                  "evening1": "in the evening",
                  "night1": "at night"
                },
                "wide": {
                  "midnight": "midnight",
                  "am": "AM",
                  "am-alt-variant": "am",
                  "noon": "noon",
                  "pm": "PM",
                  "pm-alt-variant": "pm",
                  "morning1": "in the morning",
                  "afternoon1": "in the afternoon",
                  "evening1": "in the evening",
                  "night1": "at night"
                }
              },
              "stand-alone": {
                "abbreviated": {
                  "midnight": "midnight",
                  "am": "AM",
                  "am-alt-variant": "am",
                  "noon": "noon",
                  "pm": "PM",
                  "pm-alt-variant": "pm",
                  "morning1": "morning",
                  "afternoon1": "afternoon",
                  "evening1": "evening",
                  "night1": "night"
                },
                "narrow": {
                  "midnight": "midnight",
                  "am": "AM",
                  "am-alt-variant": "am",
                  "noon": "noon",
                  "pm": "PM",
                  "pm-alt-variant": "pm",
                  "morning1": "morning",
                  "afternoon1": "afternoon",
                  "evening1": "evening",
                  "night1": "night"
                },
                "wide": {
                  "midnight": "midnight",
                  "am": "AM",
                  "am-alt-variant": "am",
                  "noon": "noon",
                  "pm": "PM",
                  "pm-alt-variant": "pm",
                  "morning1": "morning",
                  "afternoon1": "afternoon",
                  "evening1": "evening",
                  "night1": "night"
                }
              }
            },
            "eras": {
              "eraNames": {
                "0": "Before Christ",
                "0-alt-variant": "Before Common Era",
                "1": "Anno Domini",
                "1-alt-variant": "Common Era"
              },
              "eraAbbr": {
                "0": "BC",
                "0-alt-variant": "BCE",
                "1": "AD",
                "1-alt-variant": "CE"
              },
              "eraNarrow": {
                "0": "B",
                "0-alt-variant": "BCE",
                "1": "A",
                "1-alt-variant": "CE"
              }
            },
            "dateFormats": {
              "full": "EEEE, MMMM d, y",
              "long": "MMMM d, y",
              "medium": "MMM d, y",
              "short": "M/d/yy"
            },
            "dateSkeletons": {
              "full": "yMMMMEEEEd",
              "long": "yMMMMd",
              "medium": "yMMMd",
              "short": "yyMd"
            },
            "timeFormats": {
              "full": "h:mm:ss a zzzz",
              "full-alt-ascii": "h:mm:ss a zzzz",
              "long": "h:mm:ss a z",
              "long-alt-ascii": "h:mm:ss a z",
              "medium": "h:mm:ss a",
              "medium-alt-ascii": "h:mm:ss a",
              "short": "h:mm a",
              "short-alt-ascii": "h:mm a"
            },
            "timeSkeletons": {
              "full": "ahmmsszzzz",
              "long": "ahmmssz",
              "medium": "ahmmss",
              "short": "ahmm"
            },
            "dateTimeFormats": {
              "full": "{1}, {0}",
              "long": "{1}, {0}",
              "medium": "{1}, {0}",
              "short": "{1}, {0}",
              "availableFormats": {
                "Bh": "h B",
                "Bhm": "h:mm B",
                "Bhms": "h:mm:ss B",
                "d": "d",
                "E": "ccc",
                "EBh": "E h B",
                "EBhm": "E h:mm B",
                "EBhms": "E h:mm:ss B",
                "Ed": "d E",
                "Eh": "E h a",
                "Eh-alt-ascii": "E h a",
                "Ehm": "E h:mm a",
                "Ehm-alt-ascii": "E h:mm a",
                "EHm": "E HH:mm",
                "Ehms": "E h:mm:ss a",
                "Ehms-alt-ascii": "E h:mm:ss a",
                "EHms": "E HH:mm:ss",
                "Gy": "y G",
                "GyM": "M/y G",
                "GyMd": "M/d/y G",
                "GyMEd": "E, M/d/y G",
                "GyMMM": "MMM y G",
                "GyMMMd": "MMM d, y G",
                "GyMMMEd": "E, MMM d, y G",
                "h": "h a",
                "h-alt-ascii": "h a",
                "H": "HH",
                "hm": "h:mm a",
                "hm-alt-ascii": "h:mm a",
                "Hm": "HH:mm",
                "hms": "h:mm:ss a",
                "hms-alt-ascii": "h:mm:ss a",
                "Hms": "HH:mm:ss",
                "hmsv": "h:mm:ss a v",
                "hmsv-alt-ascii": "h:mm:ss a v",
                "Hmsv": "HH:mm:ss v",
                "hmv": "h:mm a v",
                "hmv-alt-ascii": "h:mm a v",
                "Hmv": "HH:mm v",
                "hv": "h a v",
                "hv-alt-ascii": "h a v",
                "Hv": "HH'h' v",
                "M": "L",
                "Md": "M/d",
                "MEd": "E, M/d",
                "MMM": "LLL",
                "MMMd": "MMM d",
                "MMMEd": "E, MMM d",
                "MMMMd": "MMMM d",
                "MMMMW-count-one": "'week' W 'of' MMMM",
                "MMMMW-count-other": "'week' W 'of' MMMM",
                "ms": "mm:ss",
                "y": "y",
                "yM": "M/y",
                "yMd": "M/d/y",
                "yMEd": "E, M/d/y",
                "yMMM": "MMM y",
                "yMMMd": "MMM d, y",
                "yMMMEd": "E, MMM d, y",
                "yMMMM": "MMMM y",
                "yQQQ": "QQQ y",
                "yQQQQ": "QQQQ y",
                "yw-count-one": "'week' w 'of' Y",
                "yw-count-other": "'week' w 'of' Y"
              },
              "appendItems": {
                "Day": "{0} ({2}: {1})",
                "Day-Of-Week": "{0} {1}",
                "Era": "{0} {1}",
                "Hour": "{0} ({2}: {1})",
                "Minute": "{0} ({2}: {1})",
                "Month": "{0} ({2}: {1})",
                "Quarter": "{0} ({2}: {1})",
                "Second": "{0} ({2}: {1})",
                "Timezone": "{0} {1}",
                "Week": "{0} ({2}: {1})",
                "Year": "{0} {1}"
              },
              "intervalFormats": {
                "intervalFormatFallback": "{0} – {1}",
                "Bh": {
                  "B": "h B – h B",
                  "h": "h – h B"
                },
                "Bhm": {
                  "B": "h:mm B – h:mm B",
                  "h": "h:mm – h:mm B",
                  "m": "h:mm – h:mm B"
                },
                "d": {
                  "d": "d – d"
                },
                "Gy": {
                  "G": "y G – y G",
                  "y": "y – y G"
                },
                "GyM": {
                  "G": "M/y G – M/y G",
                  "M": "M/y – M/y G",
                  "y": "M/y – M/y G"
                },
                "GyMd": {
                  "d": "M/d/y – M/d/y G",
                  "G": "M/d/y G – M/d/y G",
                  "M": "M/d/y – M/d/y G",
                  "y": "M/d/y – M/d/y G"
                },
                "GyMEd": {
                  "d": "E, M/d/y – E, M/d/y G",
                  "G": "E, M/d/y G – E, M/d/y G",
                  "M": "E, M/d/y – E, M/d/y G",
                  "y": "E, M/d/y – E, M/d/y G"
                },
                "GyMMM": {
                  "G": "MMM y G – MMM y G",
                  "M": "MMM – MMM y G",
                  "y": "MMM y – MMM y G"
                },
                "GyMMMd": {
                  "d": "MMM d – d, y G",
                  "G": "MMM d, y G – MMM d, y G",
                  "M": "MMM d – MMM d, y G",
                  "y": "MMM d, y – MMM d, y G"
                },
                "GyMMMEd": {
                  "d": "E, MMM d – E, MMM d, y G",
                  "G": "E, MMM d, y G – E, MMM d, y G",
                  "M": "E, MMM d – E, MMM d, y G",
                  "y": "E, MMM d, y – E, MMM d, y G"
                },
                "h": {
                  "a": "h a – h a",
                  "h": "h – h a"
                },
                "H": {
                  "H": "HH – HH"
                },
                "hm": {
                  "a": "h:mm a – h:mm a",
                  "h": "h:mm – h:mm a",
                  "m": "h:mm – h:mm a"
                },
                "Hm": {
                  "H": "HH:mm – HH:mm",
                  "m": "HH:mm – HH:mm"
                },
                "hmv": {
                  "a": "h:mm a – h:mm a v",
                  "h": "h:mm – h:mm a v",
                  "m": "h:mm – h:mm a v"
                },
                "Hmv": {
                  "H": "HH:mm – HH:mm v",
                  "m": "HH:mm – HH:mm v"
                },
                "hv": {
                  "a": "h a – h a v",
                  "h": "h – h a v"
                },
                "Hv": {
                  "H": "HH – HH v"
                },
                "M": {
                  "M": "M – M"
                },
                "Md": {
                  "d": "M/d – M/d",
                  "M": "M/d – M/d"
                },
                "MEd": {
                  "d": "E, M/d – E, M/d",
                  "M": "E, M/d – E, M/d"
                },
                "MMM": {
                  "M": "MMM – MMM"
                },
                "MMMd": {
                  "d": "MMM d – d",
                  "M": "MMM d – MMM d"
                },
                "MMMEd": {
                  "d": "E, MMM d – E, MMM d",
                  "M": "E, MMM d – E, MMM d"
                },
                "y": {
                  "y": "y – y"
                },
                "yM": {
                  "M": "M/y – M/y",
                  "y": "M/y – M/y"
                },
                "yMd": {
                  "d": "M/d/y – M/d/y",
                  "M": "M/d/y – M/d/y",
                  "y": "M/d/y – M/d/y"
                },
                "yMEd": {
                  "d": "E, M/d/y – E, M/d/y",
                  "M": "E, M/d/y – E, M/d/y",
                  "y": "E, M/d/y – E, M/d/y"
                },
                "yMMM": {
                  "M": "MMM – MMM y",
                  "y": "MMM y – MMM y"
                },
                "yMMMd": {
                  "d": "MMM d – d, y",
                  "M": "MMM d – MMM d, y",
                  "y": "MMM d, y – MMM d, y"
                },
                "yMMMEd": {
                  "d": "E, MMM d – E, MMM d, y",
                  "M": "E, MMM d – E, MMM d, y",
                  "y": "E, MMM d, y – E, MMM d, y"
                },
                "yMMMM": {
                  "M": "MMMM – MMMM y",
                  "y": "MMMM y – MMMM y"
                }
              }
            },
            "dateTimeFormats-atTime": {
              "standard": {
                "full": "{1} 'at' {0}",
                "long": "{1} 'at' {0}",
                "medium": "{1}, {0}",
                "short": "{1}, {0}"
              }
            },
            "dateTimeFormats-relative": {
              "standard": {
                "full": "{1} 'at' {0}",
                "long": "{1} 'at' {0}",
                "medium": "{1}, {0}",
                "short": "{1}, {0}"
              }
            }
          }
        }
      }
    }
  }
}
